const EUCountries = {
  Austria: 'AT',
  Belgium: 'BE',
  Bulgaria: 'BG',
  Croatia: 'HR',
  Cyprus: 'CY',
  CzechRepublic: 'CZ',
  Denmark: 'DK',
  Estonia: 'EE',
  Finland: 'FI',
  France: 'FR',
  Germany: 'DE',
  Greece: 'GR',
  Hungary: 'HU',
  Ireland: 'IE',
  Italy: 'IT',
  Latvia: 'LV',
  Lithuania: 'LT',
  Luxembourg: 'LU',
  Malta: 'MT',
  Netherlands: 'NL',
  Poland: 'PL',
  Portugal: 'PT',
  Romania: 'RO',
  Slovakia: 'SK',
  Slovenia: 'SI',
  Spain: 'ES',
  Sweden: 'SE',
  Switzerland: 'CH',
  Europe: 'EU',
};

function isEU(value: string): boolean {
  return Object.values(EUCountries).includes(value);
}

enum Region {
  EU = 'EU',
  US = 'US',
  AU = 'AU',
  ID = 'ID',
  PH = 'PH',
  VN = 'VN',
  AE = 'AE',
  Global = 'Global',
}

const whichRegion = (country: string): Region => {
  if (isEU(country)) return Region.EU;

  switch (country) {
    case Region.US: {
      return Region.US;
    }
    case Region.AU: {
      return Region.AU;
    }
    case Region.ID: {
      return Region.ID;
    }
    case Region.PH: {
      return Region.PH;
    }
    case Region.VN: {
      return Region.VN;
    }
    case Region.AE: {
      return Region.AE;
    }
    default: {
      return Region.Global;
    }
  }
};

export { isEU, Region, whichRegion };
